module.exports = __webpack_public_path__ + "assets/img/3-1.b0724e5f.jpg";